<template>
    <section>
        <div class="flex items-center gap-2 flex-wrap">
            <el-button
                v-if="has_manager_ads"
                type="primary"
                size="small"
                icon="el-icon-plus"
                @click="handleRedirectToCreateCampaign()"
            >
                {{ $t('button.create') }}
            </el-button>

            <el-button
                size="small"
                class="!ml-0"
                @click="show_custom_column_dialog = true"
            >
                {{ $t('button.custom_column') }}
            </el-button>

            <div v-if="has_auto_ads">
                <el-dropdown trigger="click">
                    <el-button size="small">
                        {{ $t('common.automatic_rule') }}
                        <i class="el-icon-arrow-down"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>
                            <div
                                @click="
                                    is_create_automatic_rule_drawer_displayed = true
                                "
                            >
                                <p class="text-[0.8rem]">
                                    {{ $t('page.campaign.create_rule') }}
                                </p>
                            </div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <div
                                @click="
                                    is_manage_automatic_rule_drawer_displayed = true
                                "
                            >
                                <p class="text-[0.8rem]">
                                    {{ $t('page.campaign.manage_rule') }}
                                </p>
                            </div>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>

            <div class="!ml-auto"></div>

            <div class="flex items-center">
                <el-switch
                    v-model="m__switch_auto_refresh"
                    @change="m__handleToggleAutoRefresh"
                ></el-switch>
                <p class="text-[0.75rem] mx-1">
                    {{ $t('page.campaign.auto_refresh') }}
                </p>
                <el-tooltip
                    effect="dark"
                    :content="$t('page.campaign.desc_auto_refresh')"
                    placement="top"
                >
                    <i class="el-icon-info text-desc-text"></i>
                </el-tooltip>
            </div>

            <el-select
                v-model="m__page_info.page_size"
                filterable
                class="w-[120px]"
                size="small"
                @change="
                    m__handleChangePagesize(m__getReportCampaignsByAccount)
                "
            >
                <el-option
                    v-for="item in m__list_pagesize"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
            </el-select>

            <el-input-number
                v-model="m__page_info.page"
                class="w-[120px]"
                size="small"
                :min="1"
                :max="m__page_info.total_page"
                @change="m__getReportCampaignsByAccount"
            ></el-input-number>

            <el-button
                icon="el-icon-refresh"
                size="small"
                @click="m__getReportCampaignsByAccount"
            ></el-button>
        </div>

        <div class="mt-4 relative">
            <el-table
                ref="multipleTable"
                v-loading="m__loading"
                class="campaign-table"
                :show-summary="!name_filtering"
                max-height="560"
                :data="m__data_for_pagination"
                :summary-method="m__getSummaries"
                @selection-change="handleSelectionChange"
                @sort-change="m__handleSortChange"
            >
                <el-table-column type="selection" width="40" :fixed="true">
                </el-table-column>

                <el-table-column
                    :label="$t('table.header.on_off')"
                    :fixed="true"
                    width="60"
                >
                    <template #default="scope">
                        <el-switch
                            :value="
                                scope.row.adgroup.operation_status === 'ENABLE'
                            "
                            @change="
                                handleChangeStatusAdgroup(
                                    scope.row.adgroup.adgroup_id
                                )
                            "
                        >
                        </el-switch>
                    </template>
                </el-table-column>

                <el-table-column
                    min-width="360"
                    prop="adgroup.adgroup_name"
                    :label="$t('common.name')"
                    :fixed="true"
                >
                    <template #default="scope">
                        <div class="group hover:text-brand-atosa--light">
                            <div class="group flex items-center">
                                <div
                                    v-if="
                                        [
                                            'ADGROUP_STATUS_CAMPAIGN_DELETE',
                                            'ADGROUP_STATUS_DELETE'
                                        ].some(
                                            (item) =>
                                                item ===
                                                scope.row.adgroup
                                                    .secondary_status
                                        )
                                    "
                                    class="cursor-pointer"
                                >
                                    <el-tooltip
                                        class="item"
                                        effect="dark"
                                        :content="
                                            scope.row.adgroup.adgroup_name
                                        "
                                        placement="top"
                                    >
                                        <p class="truncate max-w-[240px]">
                                            {{ scope.row.adgroup.adgroup_name }}
                                        </p>
                                    </el-tooltip>
                                </div>
                                <div
                                    v-else
                                    class="cursor-pointer"
                                    @click="handleSelectRow(scope.row)"
                                >
                                    <el-tooltip
                                        class="item"
                                        effect="dark"
                                        :content="
                                            scope.row.adgroup.adgroup_name
                                        "
                                        placement="top"
                                    >
                                        <p
                                            class="hover:underline truncate max-w-[240px]"
                                        >
                                            {{ scope.row.adgroup.adgroup_name }}
                                        </p>
                                    </el-tooltip>
                                </div>

                                <el-tooltip
                                    effect="dark"
                                    :content="$t('common.edit_name')"
                                    placement="top"
                                >
                                    <div
                                        v-if="
                                            [
                                                'ADGROUP_STATUS_CAMPAIGN_DELETE',
                                                'ADGROUP_STATUS_DELETE'
                                            ].every(
                                                (item) =>
                                                    item !==
                                                    scope.row.adgroup
                                                        .secondary_status
                                            ) && has_manager_ads
                                        "
                                        class="ml-2 group-hover:block hidden cursor-pointer"
                                        @click="
                                            handleSelectRowToEditName(
                                                scope.row.adgroup
                                            )
                                        "
                                    >
                                        <i
                                            class="el-icon-edit text-[0.75rem] font-semibold"
                                        ></i>
                                    </div>
                                </el-tooltip>
                            </div>

                            <div
                                v-if="
                                    [
                                        'ADGROUP_STATUS_CAMPAIGN_DELETE',
                                        'ADGROUP_STATUS_DELETE'
                                    ].every(
                                        (item) =>
                                            item !==
                                            scope.row.adgroup.secondary_status
                                    )
                                "
                                class="flex items-center mt-1 space-x-3"
                            >
                                <div
                                    v-if="has_report_ads"
                                    class="hover:underline flex items-center space-x-1 cursor-pointer"
                                    @click="handleOpenViewDataDrawer(scope.row)"
                                >
                                    <font-awesome-icon
                                        icon="fa-solid fa-chart-area"
                                    ></font-awesome-icon>
                                    <p>
                                        {{ $t('button.view_data') }}
                                    </p>
                                </div>

                                <div
                                    v-if="has_manager_ads"
                                    class="flex items-center space-x-1 cursor-pointer hover:underline"
                                    @click="handleOpenEditDrawer(scope.row)"
                                >
                                    <font-awesome-icon
                                        icon="fa-regular fa-pen-to-square"
                                    ></font-awesome-icon>
                                    <p>
                                        {{ $t('common.edit') }}
                                    </p>
                                </div>

                                <div v-if="has_manager_ads">
                                    <div
                                        v-if="
                                            current_package &&
                                            current_package.extra_data
                                                .clone_campaign
                                        "
                                        class="hover:underline flex items-center space-x-1 cursor-pointer"
                                        @click="
                                            handleOpenConfirmCopy(scope.row)
                                        "
                                    >
                                        <font-awesome-icon
                                            icon="fa-regular fa-copy"
                                        />
                                        <p>
                                            {{ $t('common.copy') }}
                                        </p>
                                    </div>

                                    <div v-else>
                                        <el-tooltip
                                            class="item"
                                            effect="dark"
                                            :content="
                                                $t('common.feature_must_buy')
                                            "
                                            placement="top"
                                        >
                                            <div
                                                class="flex items-center space-x-1 cursor-not-allowed opacity-60"
                                            >
                                                <font-awesome-icon
                                                    icon="fa-regular fa-copy"
                                                />
                                                <p>
                                                    {{ $t('common.copy') }}
                                                </p>
                                            </div>
                                        </el-tooltip>
                                    </div>
                                </div>

                                <div v-if="has_manager_ads">
                                    <div
                                        v-if="
                                            current_package &&
                                            current_package.extra_data
                                                .delete_campaign
                                        "
                                        class="hover:underline flex items-center space-x-1 cursor-pointer text-red"
                                        @click="
                                            handleDeleteAdgroup(
                                                scope.row.adgroup.adgroup_id
                                            )
                                        "
                                    >
                                        <font-awesome-icon
                                            icon="fa-regular fa-trash-alt"
                                        />
                                        <p>
                                            {{ $t('button.delete') }}
                                        </p>
                                    </div>

                                    <div v-else>
                                        <el-tooltip
                                            class="item"
                                            effect="dark"
                                            :content="
                                                $t('common.feature_must_buy')
                                            "
                                            placement="top"
                                        >
                                            <div
                                                class="flex items-center space-x-1 cursor-not-allowed opacity-60"
                                            >
                                                <font-awesome-icon
                                                    icon="fa-regular fa-trash-alt"
                                                />
                                                <p>
                                                    {{ $t('button.delete') }}
                                                </p>
                                            </div>
                                        </el-tooltip>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column :label="$t('common.status')" width="200px">
                    <template #default="scope">
                        <div class="flex items-center space-x-2">
                            <div
                                class="h-2 w-2 rounded-full"
                                :style="{
                                    background: [
                                        'ADGROUP_STATUS_TIME_DONE',
                                        'ADGROUP_STATUS_DELIVERY_OK',
                                        'ADGROUP_STATUS_SHADOW_ADGROUP_REAUDIT',
                                        'ADGROUP_STATUS_PARTIAL_AUDIT_DELIVERY_OK'
                                    ].some(
                                        (item) =>
                                            item ===
                                            scope.row.adgroup.secondary_status
                                    )
                                        ? '#26cd26'
                                        : 'red'
                                }"
                            ></div>
                            <p class="font-medium">
                                {{
                                    renderLabelBySecondaryStatus(
                                        scope.row.adgroup.secondary_status
                                    )
                                }}
                            </p>
                        </div>
                        <el-tooltip
                            effect="dark"
                            :content="
                                renderDescriptionBySecondaryStatus(
                                    scope.row.adgroup.secondary_status
                                )
                            "
                            placement="top"
                        >
                            <p
                                class="text-desc-text text-[0.75rem] truncate w-[160px]"
                            >
                                {{
                                    renderDescriptionBySecondaryStatus(
                                        scope.row.adgroup.secondary_status
                                    )
                                }}
                            </p>
                        </el-tooltip>
                    </template>
                </el-table-column>

                <el-table-column
                    min-width="160"
                    :show-overflow-tooltip="true"
                    prop="adgroup.adgroup_id"
                    :label="
                        $t('common.xxx_id', {
                            xxx: $t(`common.adgroup`)
                        })
                    "
                />

                <el-table-column
                    :label="$t('page.campaign.optimization_goal')"
                    width="160px"
                >
                    <template #default="scope">
                        <p class="font-semibold">
                            {{
                                p__formatLabelOptimizationGoal(
                                    scope.row.adgroup.optimization_goal,
                                    scope.row.adgroup.optimization_event
                                )
                            }}
                        </p>
                    </template>
                </el-table-column>

                <el-table-column :label="$t('common.budget')" width="160px">
                    <template #default="scope">
                        <p class="font-semibold">
                            {{
                                p__renderMoneyByCurrency(
                                    scope.row.adgroup.budget,
                                    scope.row.currency
                                )
                            }}
                        </p>
                        <p class="component-text-desc">
                            {{
                                p__formatBudgetMode(
                                    scope.row.adgroup.budget_mode
                                )
                            }}
                        </p>
                    </template>
                </el-table-column>

                <el-table-column
                    width="120"
                    :show-overflow-tooltip="true"
                    prop="adgroup.bid_price"
                    label="BID"
                    :formatter="m__formatterColumn"
                    align="right"
                >
                    <template #default="scope">
                        <p>
                            {{
                                m__formatterColumn(
                                    scope.row.adgroup.bid_price,
                                    'bid_price',
                                    scope.row.currency
                                )
                            }}
                        </p>
                    </template>
                </el-table-column>

                <el-table-column
                    :label="$t('common.ad_scheduling')"
                    width="160px"
                >
                    <template #default="scope">
                        <p>
                            {{
                                p__formatDate(
                                    scope.row.adgroup.schedule_start_time
                                )
                            }}
                        </p>
                        <p
                            v-if="
                                scope.row.adgroup.schedule_type ===
                                'SCHEDULE_START_END'
                            "
                        >
                            {{
                                p__formatDate(
                                    scope.row.adgroup.schedule_end_time
                                )
                            }}
                        </p>
                        <p v-else>
                            {{ $t('page.campaign.on_going') }}
                        </p>
                    </template>
                </el-table-column>

                <el-table-column
                    v-for="(item, index) in m__selected_columns"
                    :key="index"
                    :min-width="160"
                    :width="m__getContentWidthColumn(item)"
                    :show-overflow-tooltip="true"
                    :prop="item"
                    :label="$t(`page.campaign.column_${item}`)"
                    sortable="custom"
                    align="right"
                >
                    <template v-slot:header>
                        <el-tooltip
                            class="item"
                            :content="$t(`page.campaign.column_${item}`)"
                            effect="dark"
                            placement="top"
                        >
                            <div slot="content">
                                <p
                                    class="text-[0.85rem]"
                                    v-html="$t(`page.campaign.column_${item}`)"
                                ></p>

                                <p
                                    v-if="
                                        $t(
                                            `page.campaign.description_column_${item}`
                                        ) !==
                                        `page.campaign.description_column_${item}`
                                    "
                                    class="mt-1"
                                    v-html="
                                        $t(
                                            `page.campaign.description_column_${item}`
                                        )
                                    "
                                ></p>
                            </div>
                            <p>
                                {{ $t(`page.campaign.column_${item}`) }}
                            </p>
                        </el-tooltip>
                    </template>

                    <template #default="scope">
                        <div>
                            <p>
                                {{
                                    m__formatterColumn(
                                        scope.row[item],
                                        item,
                                        scope.row.currency
                                    )
                                }}
                            </p>
                            <p
                                v-if="scope.row.compare"
                                class="text-desc-text font-semibold"
                            >
                                {{
                                    m__formatterColumn(
                                        scope.row.compare[item],
                                        item,
                                        scope.row.currency
                                    )
                                }}
                            </p>
                            <p
                                v-if="
                                    m__getContentWidthColumn(item) === '260px'
                                "
                                class="text-desc-text text-[0.75rem]"
                            >
                                {{
                                    p__formatLabelOptimizationGoal(
                                        scope.row.adgroup.optimization_goal,
                                        scope.row.adgroup.optimization_event
                                    )
                                }}
                            </p>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

            <div
                v-if="!m__data_for_pagination.length"
                class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
            >
                <div class="util-flex-center flex-col">
                    <img
                        class="w-[140px] h-[140px]"
                        :src="require('@/assets/images/no_data.png')"
                    />
                    <p class="mt-2 text-desc-text text-[0.9rem]">
                        {{ $t('common.no_data') }}
                    </p>
                </div>
            </div>
        </div>

        <CreateAutomaticRuleDrawer
            :visible.sync="is_create_automatic_rule_drawer_displayed"
            :tiktok_account_id="tiktok_account_id"
            :advertiser_id="advertiser_id"
            :currency="currency"
            :multiple_selection="multiple_selection"
            type="ADGROUP"
        ></CreateAutomaticRuleDrawer>

        <ManageAutomaticRuleDrawer
            :visible.sync="is_manage_automatic_rule_drawer_displayed"
            :tiktok_account_id="tiktok_account_id"
            :advertiser_id="advertiser_id"
            :currency="currency"
        ></ManageAutomaticRuleDrawer>

        <CopyDrawer
            :visible.sync="is_copy_drawer_displayed"
            :advertiser_id="advertiser_id"
            :belong_to_atosa="belong_to_atosa"
            :min_budget_adgroup="min_budget_adgroup"
            :currency="active_currency"
            :timezone="active_timezone"
            :objective_type="selected_copy_objective_type"
            :list_campaigns="list_campaigns"
            :current_balance="current_balance"
        ></CopyDrawer>

        <ConfirmCopyDialog
            :visible.sync="is_confirm_copy_dialog_displayed"
            :handle_confirm_copy="handleConfirmCopy"
            :objective_type.sync="selected_copy_objective_type"
            :advertiser_id="advertiser_id"
            :tiktok_account_id="tiktok_account_id"
            :active_item_for_copy="active_item_for_copy"
        ></ConfirmCopyDialog>

        <CustomColumnDialog
            :column_values.sync="m__performance_column_values"
            :visible.sync="show_custom_column_dialog"
        ></CustomColumnDialog>

        <EditDrawer
            :visible.sync="is_edit_drawer_displayed"
            :selected_item="active_item_for_edit"
            :tiktok_account_id="tiktok_account_id"
            :advertiser_id="advertiser_id"
            :belong_to_atosa="belong_to_atosa"
        ></EditDrawer>

        <ViewDataDrawer
            :visible.sync="is_view_data_drawer_displayed"
            :selected_item="active_item_for_view_data"
            :tiktok_account_id="tiktok_account_id"
            :advertiser_id="advertiser_id"
            :ranger_date="ranger_date"
            :belong_to_atosa="belong_to_atosa"
            type="adgroup_id"
        ></ViewDataDrawer>

        <el-dialog
            :visible.sync="visible_edit_name_dialog"
            width="400px"
            class="el-dialog-center"
            :show-close="false"
            :append-to-body="true"
            :close-on-click-modal="true"
        >
            <template slot="title">
                <p
                    class="text-left truncate w-4/5 text-[0.95rem] font-semibold"
                >
                    {{ `${$t('common.edit_name')}` }}
                </p>
                <p
                    v-if="selected_row_to_edit_name"
                    class="text-desc-text truncate w-4/5 text-[0.8rem]"
                >
                    #{{ selected_row_to_edit_name.campaign_id }}
                </p>
            </template>

            <div v-if="selected_row_to_edit_name">
                <el-input
                    v-model="selected_row_to_edit_name.adgroup_name"
                    size="small"
                    :placeholder="$t('input.placeholder.please_input')"
                ></el-input>
            </div>

            <template slot="footer">
                <div
                    v-if="selected_row_to_edit_name"
                    class="flex items-center justify-end"
                >
                    <el-button
                        size="small"
                        @click="visible_edit_name_dialog = false"
                    >
                        {{ $t('button.close') }}
                    </el-button>
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-check"
                        :disabled="!selected_row_to_edit_name.adgroup_name"
                        @click="handleConfirmEditNameRow"
                    >
                        {{ $t('button.confirm') }}
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </section>
</template>

<script>
import campaignMixin from '../_mixin'
import CopyDrawer from './copy-drawer'
import EditDrawer from './edit-drawer'
import ConfirmCopyDialog from './confirm-copy-dialog'
import {
    updateAdgroupStatus,
    updateAdgroup
} from '@/services/atosa-tiktok-ads/adgroup'
import CustomColumnDialog from '@/views/campaign/_components/custom-column-dialog'
import ViewDataDrawer from '@/views/campaign/_components/view-data-drawer'
import CreateAutomaticRuleDrawer from '@/views/campaign/_components/atosa-create-automatic-rule-drawer'
import ManageAutomaticRuleDrawer from '@/views/campaign/_components/atosa-manage-automatic-rule-drawer'

export default {
    components: {
        ViewDataDrawer,
        EditDrawer,
        CopyDrawer,
        CreateAutomaticRuleDrawer,
        ManageAutomaticRuleDrawer,
        ConfirmCopyDialog,
        CustomColumnDialog
    },

    mixins: [campaignMixin],

    props: ['multiple_selection_campaign', 'min_budget_adgroup'],

    data() {
        return {
            is_manage_automatic_rule_drawer_displayed: false,
            is_create_automatic_rule_drawer_displayed: false,
            active_item_for_view_data: null,
            is_view_data_drawer_displayed: false,
            visible_edit_name_dialog: false,
            selected_row_to_edit_name: null,
            selected_copy_objective_type: '',
            show_custom_column_dialog: false,
            active_currency: null,
            active_timezone: null,
            active_item_for_copy: null,
            active_item_for_edit: null,
            list_copy: [],
            list_campaigns: [],
            is_confirm_copy_dialog_displayed: false,
            is_edit_drawer_displayed: false,
            is_copy_drawer_displayed: false
        }
    },

    computed: {
        multiple_selection_inline: {
            get() {
                return this.multiple_selection
            },
            set(value) {
                this.$emit('update:multiple_selection', value)
            }
        }
    },

    watch: {
        multiple_selection() {
            if (!this.multiple_selection_inline.length) {
                this.$refs.multipleTable.clearSelection([])
            }
        },

        multiple_selection_campaign() {
            const indexFilterById = this.m__filtering.findIndex(
                (item) => item.field_name === 'campaign_ids'
            )

            if (indexFilterById > -1) {
                this.m__filtering.splice(indexFilterById, 1)
            }

            if (this.multiple_selection_campaign.length) {
                const filter = {
                    filter_value: JSON.stringify(
                        this.multiple_selection_campaign.map((item) => item.id)
                    ),
                    field_name: 'campaign_ids',
                    filter_type: 'IN'
                }
                this.m__filtering.push(filter)
            }
            this.m__page_info.page = 1

            this.m__getReportCampaignsByAccount()
        }
    },

    mounted() {
        this.m__type = 'adgroup_id'
        this.m__getReportCampaignsByAccount()

        this.p__event_bus.$on(
            'eb_reload_adgroup',
            this.m__getReportCampaignsByAccount
        )

        const temp = localStorage.getItem(
            `performance_column_values_${this.m__type}`
        )
        if (temp && temp.length) {
            this.m__performance_column_values = JSON.parse(temp)
        } else {
            this.m__performance_column_values = [
                {
                    value: 'BASIC_DATA',
                    child_values: [
                        'spend',
                        'cpc',
                        'cpm',
                        'impressions',
                        'clicks',
                        'ctr',
                        'conversion',
                        'cost_per_conversion',
                        'conversion_rate'
                    ]
                }
            ]
        }
    },

    destroyed() {
        this.p__event_bus.$off(
            'eb_reload_adgroup',
            this.m__getReportCampaignsByAccount
        )
    },

    methods: {
        handleRedirectToCreateCampaign() {
            if (this.multiple_selection_campaign.length === 0) {
                this.$router.push({
                    path: `${this.p__group_route.ads_manager}/${this.p__route.create_campaign}`
                })
                return
            }

            this.$router.push({
                path: `${this.p__group_route.ads_manager}/${
                    this.p__route.create_campaign
                }?campaign_id=${this.multiple_selection_campaign
                    .map((item) => item.id)
                    .join(',')}`
            })
        },

        renderLabelBySecondaryStatus(status) {
            if (!status) {
                return this.$t('common.not_delivering')
            }

            if (
                [
                    'ADGROUP_STATUS_PARTIAL_AUDIT_DELIVERY_OK',
                    'ADGROUP_STATUS_SHADOW_ADGROUP_REAUDIT',
                    'ADGROUP_STATUS_DELIVERY_OK'
                ].some((item) => item === status)
            ) {
                return this.$t('common.active')
            }

            if (
                [
                    'ADGROUP_STATUS_CAMPAIGN_DISABLE',
                    'ADGROUP_STATUS_DISABLE'
                ].some((item) => item === status)
            ) {
                return this.$t('common.inactive')
            }

            if (
                [
                    'ADGROUP_STATUS_CAMPAIGN_DELETE',
                    'ADGROUP_STATUS_DELETE'
                ].some((item) => item === status)
            ) {
                return this.$t('common.deleted')
            }

            if (status === 'ADGROUP_STATUS_TIME_DONE') {
                return this.$t('common.completed')
            }

            if (
                [
                    'ADGROUP_STATUS_ADVERTISER_AUDIT_DENY',
                    'ADGROUP_STATUS_ADVERTISER_AUDIT',
                    'ADVERTISER_CONTRACT_PENDING',
                    'ADVERTISER_ACCOUNT_PUNISH',
                    'ADGROUP_STATUS_BALANCE_EXCEED',
                    'ADGROUP_STATUS_CREATE',
                    'ADGROUP_STATUS_TRANSCODING_FAIL',
                    'ADGROUP_STATUS_AUDIT',
                    'ADGROUP_STATUS_REAUDIT',
                    'ADGROUP_STATUS_AUDIT_DENY',
                    'ADGROUP_STATUS_PARTIAL_AUDIT_NO_DELIVERY',
                    'ADGROUP_STATUS_LIVE_NOT_START',
                    'ADGROUP_STATUS_INDUSTRY_QUALIFICATION_MISSING',
                    'ADGROUP_STATUS_INDUSTRY_QUALIFICATION_EXPIRED',
                    'ADGROUP_STATUS_INDUSTRY_QUALIFICATION_DENY',
                    'ADGROUP_STATUS_CAMPAIGN_EXCEED',
                    'ADGROUP_STATUS_BUDGET_EXCEED',
                    'ADGROUP_STATUS_FROZEN',
                    'ADGROUP_STATUS_NOT_START',
                    'ADGROUP_STATUS_ASSET_AUTHORIZATION_LOST',
                    'ADGROUP_STATUS_PIXEL_UNBIND'
                ].some((item) => item === status)
            ) {
                return this.$t('common.not_delivering')
            }

            return status
        },

        renderDescriptionBySecondaryStatus(status) {
            if (status === 'ADGROUP_STATUS_CAMPAIGN_DELETE') {
                return this.$t('page.campaign.adgroup_status_campaign_deleted')
            }
            if (status === 'ADGROUP_STATUS_DELETE') {
                return this.$t('page.campaign.adgroup_status_adgroup_deleted')
            }
            if (status === 'ADGROUP_STATUS_CAMPAIGN_DISABLE') {
                return this.$t('page.campaign.adgroup_status_campaign_inactive')
            }
            if (status === 'ADGROUP_STATUS_DISABLE') {
                return this.$t('page.campaign.adgroup_status_adgroup_inactive')
            }
            if (status === 'ADGROUP_STATUS_ADVERTISER_AUDIT_DENY') {
                return this.$t(
                    'page.campaign.campaign_status_account_not_approved'
                )
            }
            if (status === 'ADGROUP_STATUS_ADVERTISER_AUDIT') {
                return this.$t(
                    'page.campaign.campaign_status_account_in_review'
                )
            }
            if (status === 'ADVERTISER_CONTRACT_PENDING') {
                return this.$t(
                    'page.campaign.adgroup_status_contract_has_not_taken_effect'
                )
            }
            if (status === 'ADVERTISER_ACCOUNT_PUNISH') {
                return this.$t('page.campaign.adgroup_status_account_penalized')
            }
            if (status === 'ADGROUP_STATUS_BALANCE_EXCEED') {
                return this.$t(
                    'page.campaign.adgroup_status_payment_unsuccessful_or_insufficient_balance'
                )
            }
            if (status === 'ADGROUP_STATUS_CREATE') {
                return this.$t('page.campaign.adgroup_status_no_creatives')
            }
            if (status === 'ADGROUP_STATUS_TRANSCODING_FAIL') {
                return this.$t(
                    'page.campaign.adgroup_status_unable_to_convert_video_upload_again'
                )
            }
            if (status === 'ADGROUP_STATUS_AUDIT') {
                return this.$t('page.campaign.adgroup_status_in_review')
            }
            if (status === 'ADGROUP_STATUS_REAUDIT') {
                return this.$t('page.campaign.adgroup_status_edited_for_review')
            }
            if (status === 'ADGROUP_STATUS_AUDIT_DENY') {
                return this.$t('page.campaign.adgroup_status_not_approved')
            }
            if (status === 'ADGROUP_STATUS_PARTIAL_AUDIT_NO_DELIVERY') {
                return this.$t('page.campaign.adgroup_status_in_review')
            }
            if (status === 'ADGROUP_STATUS_LIVE_NOT_START') {
                return this.$t('page.campaign.adgroup_status_LIVE_not_started')
            }
            if (status === 'ADGROUP_STATUS_INDUSTRY_QUALIFICATION_MISSING') {
                return this.$t(
                    'page.campaign.adgroup_status_qualification_needed'
                )
            }
            if (status === 'ADGROUP_STATUS_INDUSTRY_QUALIFICATION_EXPIRED') {
                return this.$t('page.campaign.adgroup_status_expired')
            }
            if (status === 'ADGROUP_STATUS_INDUSTRY_QUALIFICATION_DENY') {
                return this.$t('page.campaign.adgroup_status_disapproved')
            }
            if (status === 'ADGROUP_STATUS_CAMPAIGN_EXCEED') {
                return this.$t(
                    'page.campaign.campaign_status_campaign_out_of_budget'
                )
            }
            if (status === 'ADGROUP_STATUS_BUDGET_EXCEED') {
                return this.$t(
                    'page.campaign.adgroup_status_ad_group_out_of_budget'
                )
            }
            if (status === 'ADGROUP_STATUS_NOT_START') {
                return this.$t(
                    'page.campaign.adgroup_status_outside_of_schedule'
                )
            }
            if (status === 'ADGROUP_STATUS_ASSET_AUTHORIZATION_LOST') {
                return this.$t(
                    'page.campaign.adgroup_status_asset_unavailable_or_authorization_revoked'
                )
            }
            if (status === 'ADGROUP_STATUS_PIXEL_UNBIND') {
                return this.$t(
                    'page.campaign.adgroup_status_pixel_unauthorized'
                )
            }
            if (status === 'ADGROUP_STATUS_SHADOW_ADGROUP_REAUDIT') {
                return this.$t('page.campaign.adgroup_status_edited_for_review')
            }
            if (status === 'ADGROUP_STATUS_TIME_DONE') {
                return ''
            }
            if (status === 'ADGROUP_STATUS_DELIVERY_OK') {
                return ''
            }

            return status
        },

        handleOpenViewDataDrawer(row) {
            this.active_item_for_view_data = { ...row }
            this.is_view_data_drawer_displayed = true
        },

        handleSelectRowToEditName(row) {
            this.visible_edit_name_dialog = true
            this.selected_row_to_edit_name = { ...row }
        },

        async handleConfirmEditNameRow() {
            try {
                await updateAdgroup(this.tiktok_account_id, {
                    advertiser_id: this.advertiser_id,
                    adgroup_name: this.selected_row_to_edit_name.adgroup_name,
                    adgroup_id: this.selected_row_to_edit_name.adgroup_id,
                    belong_to_atosa: this.belong_to_atosa
                })

                this.m__getReportCampaignsByAccount()
                this.visible_edit_name_dialog = false

                this.p__showNotify(
                    'success',
                    this.$t('common.update_data_success')
                )
            } catch (error) {
                console.error(error)
            }
        },

        handleSelectionChange(val) {
            this.multiple_selection_inline = val
        },

        async handleChangeStatusAdgroup(adgroup_id) {
            const adgroup = this.m__data_for_pagination.find(
                (item) => item.adgroup.adgroup_id === adgroup_id
            )

            if (!adgroup) {
                return
            }

            adgroup.adgroup.operation_status =
                adgroup.adgroup.operation_status === 'ENABLE'
                    ? 'DISABLE'
                    : 'ENABLE'
            try {
                await updateAdgroupStatus(this.tiktok_account_id, {
                    advertiser_id: this.advertiser_id,
                    adgroup_ids: [adgroup_id],
                    belong_to_atosa: this.belong_to_atosa,
                    operation_status: adgroup.adgroup.operation_status
                })

                this.m__getReportCampaignsByAccount()

                this.p__showNotify(
                    'success',
                    this.$t('page.campaign.message_update_status_xxx_success', {
                        xxx: this.$t(`common.adgroup`)
                    })
                )
            } catch (error) {
                console.error(error)

                adgroup.adgroup.operation_status =
                    adgroup.adgroup.operation_status === 'ENABLE'
                        ? 'DISABLE'
                        : 'ENABLE'

                this.p__showNotify(
                    'error',
                    this.$t('page.campaign.message_update_status_xxx_failed', {
                        xxx: this.$t(`common.adgroup`)
                    })
                )
            }
        },

        async handleDeleteAdgroup(adgroup_id) {
            try {
                await this.$confirm(
                    this.$t('common.delete_data_confirm'),
                    this.$t('common.warning'),
                    {
                        confirmButtonText: this.$t('button.confirm'),
                        cancelButtonText: this.$t('button.close'),
                        type: 'warning'
                    }
                )
            } catch (e) {
                return
            }

            const adgroup = this.m__data_for_pagination.find(
                (item) => item.adgroup.adgroup_id === adgroup_id
            )

            if (!adgroup) {
                return
            }

            try {
                await updateAdgroupStatus(this.tiktok_account_id, {
                    advertiser_id: this.advertiser_id,
                    adgroup_ids: [adgroup_id],
                    operation_status: 'DELETE',
                    belong_to_atosa: this.belong_to_atosa
                })
                adgroup.adgroup.secondary_status = 'ADGROUP_STATUS_DELETE'

                this.p__event_bus.$emit('eb_reload_adgroup')
                this.p__event_bus.$emit('eb_reload_ad')

                this.p__showNotify(
                    'success',
                    this.$t('page.campaign.message_delete_xxx_success', {
                        xxx: this.$t(`common.adgroup`)
                    })
                )
            } catch (error) {
                console.error(error)

                adgroup.adgroup.secondary_status = 'ADGROUP_STATUS_DISABLE'

                this.p__showNotify(
                    'error',
                    this.$t('page.campaign.message_delete_xxx_failed', {
                        xxx: this.$t(`common.adgroup`)
                    })
                )
            }
        },

        handleOpenEditDrawer(adgroup) {
            this.active_item_for_edit = {
                ...adgroup,
                adgroup: {
                    ...adgroup.adgroup,
                    schedule_start_time: this.p__formatDate(
                        adgroup.adgroup.schedule_start_time
                    ),
                    schedule_end_time: this.p__formatDate(
                        adgroup.adgroup.schedule_end_time
                    )
                }
            }
            this.is_edit_drawer_displayed = true
        },

        handleSelectRow(row) {
            this.handle_select_row(row.adgroup.adgroup_id)

            this.multiple_selection_inline = [row]

            this.toggleSelection([row])
        },

        toggleSelection(rows) {
            if (rows) {
                rows.forEach((row) => {
                    this.$refs.multipleTable.toggleRowSelection(row)
                })
            } else {
                this.$refs.multipleTable.clearSelection()
            }
        },

        handleOpenConfirmCopy(data) {
            this.active_item_for_copy = data.adgroup
            this.active_currency = data.currency
            this.active_timezone = data.timezone

            this.is_confirm_copy_dialog_displayed = true
        },

        handleConfirmCopy(list_campaigns) {
            this.list_campaigns = list_campaigns

            this.is_copy_drawer_displayed = true
        }
    }
}
</script>
